import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { InputGroup, InputProps } from '@/common'

export default function EmailInputGroup(props: InputProps) {
  const { t } = useTranslation()
  const [emailError, setEmailError] = useState<string | undefined>(undefined)

  const validateEmail = (email: string) => {
    if (!email) {
      setEmailError(undefined)
      return
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/
    if (!emailRegex.test(email)) {
      setEmailError(t('errors.invalidEmail'))
    } else {
      setEmailError(undefined)
    }
  }

  const handleChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    if (props.onChange) {
      props.onChange(evt)
    }
  }

  const handleBlur = (evt: React.FocusEvent<HTMLInputElement>) => {
    validateEmail(evt.target.value)
    if (props.onBlur) {
      props.onBlur(evt)
    }
  }

  return (
    <InputGroup
      {...props}
      onChange={handleChange}
      onBlur={handleBlur}
      error={emailError || props.error}
    />
  )
}
